import { i18n } from '@lt/localization';

export const VISA_TYPES = {
  NO_VISA: 'no_visa',
  ONLINE_VISA: 'online',
  ON_ARRIVAL_VISA: 'on_arrival',
  SCHENGEN_VISA: 'schengen',
  VISA_NEEDED: 'visa',
} as const;

export const VISA_NAMES = {
  [VISA_TYPES.NO_VISA]: i18n.t('checkout.visa.noVisa.names'),
  [VISA_TYPES.ONLINE_VISA]: i18n.t('checkout.visa.online'),
  [VISA_TYPES.ON_ARRIVAL_VISA]: i18n.t('checkout.visa.onArrival.names'),
  [VISA_TYPES.SCHENGEN_VISA]: i18n.t('checkout.visa.schengen'),
  [VISA_TYPES.VISA_NEEDED]: i18n.t('checkout.visa.needed'),
} as const;

export const VISA_SERVICES = {
  NO_VISA: {
    id: 'no_visa',
    label: i18n.t('checkout.visa.noVisa.services'),
  },
  VISA_FULL: {
    id: 'visa_full',
    label: i18n.t('checkout.visa.full'),
  },
  VISA_DOCS: {
    id: 'visa_docs',
    label: i18n.t('checkout.visa.docs'),
  },
} as const;
